import React, {Component} from 'react'
import {Control, Errors, actions} from 'react-redux-form'
import PropTypes from 'prop-types';

import './image-upload.css'
import no_photo from '../../../../assets/img/no_photo.png'
import VideoThumbnail from 'react-video-thumbnail';

class ImageUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      imageError: false,
    };
  }

  handleImageChange = (model, value) => {
    const reader = new FileReader();
    const file = value[0];

    if(file){
      const fileSize = this.checkFileSize(file.size);
      const fileType = this.checkFileType(file.type);

      const errors = [];

      if (!fileSize) {
        errors.push('The selected file reaches the upload limit (1MB)')
      }

      if (!fileType) {
        errors.push('The selected file is not a valid image file')
      }

      if (!errors.length) {
        reader.onloadend = () => {
          this.setState({
            file:            file,
            imagePreviewUrl: reader.result
          });
          this.props.onImageLoaded && this.props.onImageLoaded(reader.result);
        };

        reader.readAsDataURL(file);
      } else {
        this.setState({
          file:            '',
          imagePreviewUrl: no_photo,
        });
        this.props.onImageLoaded && this.props.onImageLoaded(null);
      }
    }

    return (dispatch) => {
      dispatch(actions.change(model, file));
    };
  };

  checkFileType = (type) => {
    return !type || !this.props.type || this.props.type.some((val) => val === type);
  };

  checkFileSize = (size) => {
    return !size || !this.props.sizeLimit || size < this.props.sizeLimit;
  };

  handleImageError = ()=> {
    if(this.props.acceptsVideo){
      this.setState({
        imageError: true
      });
    }
  }

  handleImageLoad = () => {
    if(this.props.acceptsVideo){
      this.setState({
        imageError: false
      });
    }
  }

  render() {
    let {imagePreviewUrl, imageError} = this.state;
    if (!imagePreviewUrl) {
      imagePreviewUrl = this.props.source;
    }

    let $imagePreview = (
      <img src={imagePreviewUrl || no_photo}
           alt={'Error loading photo ' + (this.props.source ? this.props.source : '')}
           onError={this.handleImageError}
           onLoad={this.handleImageLoad}/>);
    return (
      <div className="previewComponent form-group">
        <div className="imgPreview">
          {
            !imageError ? (
              $imagePreview
            ) : (
              <VideoThumbnail
                videoUrl={imagePreviewUrl}
              />
            )
          }
        </div>

        <Control.file className="fileInput"
                      id={this.props.model}
                      name={this.props.model}
                      model={this.props.model}
                      validators={{
                        fileSize: (val) => !val || this.checkFileSize(val.size),
                        fileType: (val) => !val || this.checkFileType(val.type),
                        required: (val) => !this.props.required || this.props.source || val
                      }}
                      changeAction={this.handleImageChange}/>
        <h4>{this.props.label}{this.props.required && '*'}</h4>
        <label htmlFor={this.props.model} className="btn btn-form btn-form-grey">{this.props.buttonLabel}</label>
        <div>{this.state.file.name}</div>

        <Errors
          show={{touched: true}}
          className="errors"
          model={this.props.model}
          messages={{
            fileSize: `The selected file reaches the upload limit (${this.props.sizeLimit / 1024} Kb)`,
            fileType: 'The selected file is not a valid image file',
            required: 'This field is required'
          }}/>
      </div>
    )
  }
}

ImageUpload.propTypes = {
  model:         PropTypes.string.isRequired,
  label:         PropTypes.string,
  onImageLoaded: PropTypes.func,
  type:          PropTypes.arrayOf(PropTypes.string),
  sizeLimit:     PropTypes.number,
  required:      PropTypes.bool,
  acceptsVideo:  PropTypes.bool,
};

ImageUpload.defaultProps = {
  model:       '.image',
  label:       'Upload a photo',
  buttonLabel: 'Choose a file',
  acceptsVideo: false
};

export default ImageUpload



// WEBPACK FOOTER //
// ./src/components/common/form/elements/image-upload.jsx